import type { MenuItem } from "@core/schema/MenuItem.js";

export function isMenuActive(menuItem: MenuItem, currentPath: string): boolean {
	const menuUrl = new URL(menuItem.href, "https://example.com");
	if (currentPath === menuUrl.pathname) {
		return true;
	}

	if (menuItem.submenuItems) {
		return menuItem.submenuItems.some((menuItem) => isMenuActive(menuItem, currentPath));
	}

	return false;
}
